import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import { puede } from "../../../../permisos/permisos";

function ListadoMoldesInyeccion() {
  const { user } = useContext(AuthContext);
  const URL_MOLDES = process.env.REACT_APP_URL_MOLDES_INYECCION;
  const URL_MAQUINAS = process.env.REACT_APP_URL_MAQUINAS;
  const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [moldes, setMoldes] = useState([]);
  const [maquinas, setMaquinas] = useState([]);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [idEdit, setIdEdit] = useState(null);

  const [nombre, setNombre] = useState("");
  const [clave, setClave] = useState("");
  const [cavidades, setCavidades] = useState(1);
  const [gramaje, setGramaje] = useState(0);
  const [ciclo, setCiclo] = useState(0);
  const [rosca, setRosca] = useState("");
  const [buscar, setBuscar] = useState("");
  const [filtroMaquina, setFiltroMaquina] = useState("");
  const [maquinasSel, setMaquinasSel] = useState([]);

  useEffect(() => {
    getMoldes();
    // Orden natural: M1, M2 ... M19, luego APF, INYECTORA, PF...
    axios
      .get(URL_MAQUINAS, headers)
      .then((r) => setMaquinas(r.data.sort((x, y) => x.nombre.localeCompare(y.nombre, "es", { numeric: true }))))
      .catch((e) => console.log(e));
  }, []);
  function getMoldes() {
    axios.get(URL_MOLDES, headers).then((r) => setMoldes(r.data)).catch((e) => console.log(e));
  }

  function abreNuevo() {
    setIdEdit(null); setNombre(""); setClave(""); setCavidades(1); setGramaje(0); setCiclo(0); setRosca(""); setMaquinasSel([]); toggle();
  }
  function abreEdit(a) {
    setIdEdit(a._id); setNombre(a.nombre); setClave(a.clave || ""); setCavidades(a.cavidades || 1);
    setGramaje(a.gramaje || 0); setCiclo(a.ciclo || 0); setRosca(a.rosca || "");
    setMaquinasSel((a.maquinas || []).map((m) => (m._id ? m._id : m)));
    toggle();
  }

  // Orden: por maquina (M1, M2... M19, luego PF/APF/INYECTORA) y gramaje.
  const numMaq = (m) => {
    const n = parseInt(String((m.maquinas || [])[0]?.nombre || "").replace(/\D/g, ""), 10);
    return isNaN(n) ? 999 : n;
  };
  const moldesFiltrados = moldes
    .filter((a) => !filtroMaquina || (a.maquinas || []).some((m) => (m._id || m) === filtroMaquina))
    .filter((a) => {
      if (!buscar) return true;
      const t = buscar.toLowerCase();
      return `${a.nombre} ${a.clave} ${a.rosca}`.toLowerCase().includes(t);
    })
    .sort((a, b) => numMaq(a) - numMaq(b) || String((a.maquinas || [])[0]?.nombre).localeCompare(String((b.maquinas || [])[0]?.nombre)) || b.gramaje - a.gramaje);

  function toggleMaquina(id) {
    setMaquinasSel((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  }

  function guardar() {
    const body = {
      nombre, clave,
      cavidades: Number(cavidades), gramaje: Number(gramaje), ciclo: Number(ciclo),
      rosca: String(rosca || "").trim().toUpperCase(),
      maquinas: maquinasSel,
    };
    const req = idEdit
      ? axios.patch(`${URL_MOLDES}/${idEdit}`, body, headers)
      : axios.post(URL_MOLDES, body, headers);
    req
      .then(() => { toggle(); Swal.fire("Good job!", "Guardado con exito", "success"); window.location.reload(); })
      .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? error.response.data : error}` }));
  }

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puede(user, "catalogos.moldes.ver") ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-fill-drip" style={{ marginRight: 8, color: "#6366f1" }} />
                  Moldes de Inyección
                </h3>
                <p className="page-subtitle">Preformas — cavidades, gramaje y ciclo</p>
              </div>
              <div className="page-actions">
                {puede(user, "catalogos.moldes.crear") && (
<Button size="sm" color="success" onClick={abreNuevo}>
                  <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nuevo Molde
                </Button>
)}
              </div>
            </div>
            <Row style={{ marginBottom: 10 }}>
              <Col md={4}>
                <Input bsSize="sm" placeholder="Buscar (nombre, clave, rosca)..." value={buscar} onChange={(e) => setBuscar(e.target.value)} />
              </Col>
              <Col md={3}>
                <Input bsSize="sm" type="select" value={filtroMaquina} onChange={(e) => setFiltroMaquina(e.target.value)}>
                  <option value="">Todas las máquinas</option>
                  {maquinas.map((m) => (
                    <option key={m._id} value={m._id}>{m.nombre}</option>
                  ))}
                </Input>
              </Col>
            </Row>
            <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
              <thead>
                <tr>
                  <th className="tituloTabla">Nombre</th>
                  <th className="tituloTabla">Clave</th>
                  <th className="tituloTabla">Cavidades</th>
                  <th className="tituloTabla">Gramaje (g)</th>
                  <th className="tituloTabla">Ciclo (s)</th>
                  <th className="tituloTabla">Rosca</th>
                  <th className="tituloTabla">Máquinas</th>
                  <th className="tituloTabla">Editar</th>
                </tr>
              </thead>
              <tbody>
                {moldesFiltrados.map((a) => (
                  <tr key={a._id}>
                    <td>{a.nombre}</td>
                    <td>{a.clave}</td>
                    <td>{a.cavidades}</td>
                    <td>{a.gramaje}</td>
                    <td>{a.ciclo}</td>
                    <td>{a.rosca || "-"}</td>
                    <td>{(a.maquinas || []).map((m) => m.nombre).join(", ")}</td>
                    <td>
                      {puede(user, "catalogos.moldes.editar") && (
<Button color="info" size="sm" onClick={() => abreEdit(a)}>
                        <i className="far fa-edit"></i>
                      </Button>
)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : undefined}
      </div>

      <Modal size="md" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <i className="fas fa-fill-drip" style={{ marginRight: 8, color: "#6366f1" }} />
          {idEdit ? "Editar" : "Nuevo"} Molde de Inyección
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={8}>
              <Label>Nombre *</Label>
              <Input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Clave</Label>
              <Input type="text" value={clave} onChange={(e) => setClave(e.target.value)} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={4}>
              <Label>Cavidades</Label>
              <Input type="number" value={cavidades} onChange={(e) => setCavidades(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Gramaje (g)</Label>
              <Input type="number" value={gramaje} onChange={(e) => setGramaje(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Ciclo (seg)</Label>
              <Input type="number" value={ciclo} onChange={(e) => setCiclo(e.target.value)} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={4}>
              <Label>Rosca</Label>
              <Input type="text" placeholder="R28, R24-410..." value={rosca} onChange={(e) => setRosca(e.target.value)} />
            </Col>
          </Row>
          <br />
          <Label>Máquinas compatibles</Label>
          <div style={{ maxHeight: 160, overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: 6, padding: 8 }}>
            {maquinas.length === 0 ? (
              <small className="text-muted">No hay máquinas. Crea máquinas primero.</small>
            ) : (
              maquinas.map((m) => (
                <div key={m._id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "2px 0" }}>
                  <input
                    type="checkbox"
                    checked={maquinasSel.includes(m._id)}
                    onChange={() => toggleMaquina(m._id)}
                    style={{ width: 15, height: 15, margin: 0, flexShrink: 0, cursor: "pointer" }}
                  />
                  <span>{m.nombre}</span>
                </div>
              ))
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardar}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoMoldesInyeccion;
